import { axiosInstance } from "./api";


/**
 * Get building types.
 */
export const fetchBuildingTypes = async () => {
  const response = await axiosInstance.get("/buildings/getBuildingTypes");
  if (response.data) {
    return response.data;
  }
  return [];
};

/**
 * Get connection types.
 */
export const fetchConnectionTypes = async () => {
  const response = await axiosInstance.get("/connections/connectionTypes");
  if (response.data) {
    return response.data;
  }
  return [];
};

/**
 * Get buildings for a given project.
 */
export const fetchBuildings = async (projectId) => {
  const response = await axiosInstance.get(
    `/buildings/getBuildings/${projectId}`
  );
  if (response.data) {
    return response.data;
  }
  return [];
};

/**
 * Get connections for a given project.
 */
export const fetchConnections = async (projectId) => {
  const response = await axiosInstance.get(`/connections/project/${projectId}`);
  if (response.data) {
    return response.data;
  }
  return [];
};
